import axios from 'axios'

export default {
  async all (url) {
    try {
      const response = await axios.get(url)
      return _.get(response, 'data.data', [])
    } catch (err) {
      console.error(err)
    }
    return false
  },
  async get (media) {
    try {
      const response = await axios.get(`/media/${media}`)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
    }
    return null
  },
  async destroy (media) {
    try {
      const response = await axios.delete(`/media/${media}`)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
    }
    return false
  },
  async update (media, data) {
    try {
      const response = await axios.post(`/media/${media}/edit`, data)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
    }
    return false
  }
}